import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface MyTimeWorkingFrameBoxProps {
  label: string;
  value: number | string;
  color: string;
  loading: boolean;
  typeName?: string;
  framePeriodData?: { startDate?: string | Date; endDate?: string | Date };
  overtimeValue?: number | string;
  minHeight?: string | number;
}

export const MyTimeWorkingFrameBox: React.FC<MyTimeWorkingFrameBoxProps> = ({
  label,
  value,
  color,
  loading,
  typeName,
  framePeriodData,
  overtimeValue,
  minHeight,
}) => {
  const { t } = useTranslation();

  const formatDate = (date: string | Date | undefined) =>
    date ? new Date(date).toLocaleDateString() : "";
  const theme = useTheme();

  const renderHeader = (text: string, bold = false) => (
    <Typography
      variant="body1"
      style={{
        color: theme.palette.white.main,
        padding: "0px",
        margin: "0px",
        fontWeight: bold ? "bold" : "normal",
      }}
    >
      {text}
    </Typography>
  );

  const boxSeparator = () => (
    <Box
      style={{
        backgroundColor: theme.palette.white.main,
        width: "auto",
        height: "1px",
      }}
    />
  );

  return (
    <Box
      minHeight={minHeight}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        backgroundColor: color,
        borderRadius: "8px",
      }}
    >
      <Box padding="12px 16px 0px 16px">
        {typeName === "framePeriod" && (
          <>
            {renderHeader(t("MY_TIME_FRAME_PERIOD"))}
            {renderHeader(
              loading
                ? t("OC_LOADING")
                : `${formatDate(framePeriodData?.startDate)} - ${formatDate(framePeriodData?.endDate)}`,
              true,
            )}
            <Box height="8px" />
            {boxSeparator()}
          </>
        )}
        {typeName === "frameOvertime" && (
          <>
            {renderHeader(t("MY_TIME_ACCEPTED_OVERTIME"))}
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="flex-end"
            >
              <Typography
                variant="h4"
                style={{
                  color: theme.palette.white.main,
                  lineHeight: "42.5px",
                  padding: "0px",
                  margin: "0px",
                  textTransform: "lowercase",
                }}
              >
                {loading ? t("OC_LOADING") : `${overtimeValue} ${t("OC_HOUR")}`}
              </Typography>
            </Box>
            <Box height="8px" />
            {boxSeparator()}
          </>
        )}
      </Box>
      <Box padding="8px 16px 16px 16px">
        <Typography
          variant="body1"
          style={{
            color: theme.palette.white.main,
            padding: "0px",
            margin: "0px",
          }}
        >
          {label}
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Typography
            variant="h4"
            style={{
              color: theme.palette.white.main,
              lineHeight: "42.5px",
              padding: "0px",
              margin: "0px",
              textTransform: "lowercase",
            }}
          >
            {loading ? t("OC_LOADING") : `${value} ${t("OC_HOUR")}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default MyTimeWorkingFrameBox;
